export const RATE_RESET_ENUM = {
  IN_ADVANCE: 'IN_ADVANCE',
  IN_ARREARS: 'IN_ARREARS',
  DAILY: 'DAILY',
};

